// extracted by mini-css-extract-plugin
export var badge = "_ha-2";
export var detailsPanel = "_ha-0";
export var resultRow = "_ha-1";